import React from "react";

type CTAButtonProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string;
  children: React.ReactNode;
  variant?: "default" | "small";
  className?: string;
};

export default function CTAButton({
  href,
  children,
  variant = "default",
  className = "",
  ...props
}: CTAButtonProps) {
  const base =
    "inline-flex items-center justify-center rounded-full border border-[#FF893F] transition hover:border-white/40 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white";

  const variants = {
    default:
      "font-display uppercase text-[#FF893F] px-6 pt-3 pb-2 tracking-widest hover:scale-[1.02]",
    small: "text-xs font-medium text-[#FF893F] px-5 py-1.5 hover:scale-[1.03]",
  };

  return (
    <a
      href={href}
      className={`${base} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </a>
  );
}
